import Client from "../AxiosClient";
const resource = "/private/briefingdrafts";

export default {
    async search (month="", year) {
        try {
            const result = await Client.get(`${resource}/?year=${year}${month !="" ? `&month=${month}` : ''}`);
            return result;
        } catch (error) {
            return { error: error };
        }
    },

    async getOne (id) {
        try {
            const result = await Client.get(`${resource}/${id}`);
            return result.data;
        } catch (error) {
            return { error: error };
        }
    },

    async getAttachments(reportId) {
        try {
            const result = await Client.get(`${resource}/${reportId}/attachments`);
            return result.data;
        } catch (error) {
            return { error: error };
        }
    },

    async add (briefingDraft) {
        try {
            const result = await Client.post(`${resource}`, briefingDraft);
            return result;
        } catch (error) {
            return { error: error };
        }
    },

    async update (briefingDraft) {
        try {
            const result = await Client.put(`${resource}`, briefingDraft);
            return result;
        } catch (error) {
        return { error: error };
        }
    },

    async remove (id) {
        try {
            const result = await Client.delete(`${resource}/${id}`);
            return result;
        } catch (error) {
            return { error: error };
        }
    },


}